import List from './list-TEMPLATE_VERSION'

export default List
